type WindowWithDataLayer = Window & {
    dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

let dataLayer = {}

//Push basic info to dataLayer
export function sendBaseDataLayer(basics: { [key: string]: string }) {
    dataLayer['event'] = 'pageLoad'
    dataLayer['envWork'] = basics.envWork
    dataLayer['language'] = 'fr'
    dataLayer['userAuthenticated'] = basics.userAuthenticated
    dataLayer['userId'] = basics.userId

    // window.dataLayer.push(dataLayer)
}

//Send events (on click or on element visible)
export function sendEventDataLayer(event: any, eventCategory: any, eventAction: any, eventName?: any, fromConfirmation = false, errors = 0, pageName?: any) {
    window.dataLayer = window.dataLayer || [];

    if(pageName) {
        const namesArray: string[] = []
        Object.values(pageName).forEach((value: any) => {
            namesArray.push(value)
        });
        const joinedNames = namesArray.join('/')

        dataLayer = {
            ...dataLayer,
            pageName: joinedNames,
        }
    }

    if (fromConfirmation) {
        dataLayer['event'] = event.event
        dataLayer['eventCategory'] = eventCategory.categoryName
        dataLayer['eventAction'] = eventAction.eventAction
        if (eventName && eventName.eventName != null) {
            dataLayer['eventName'] = eventName
        }
    } else {
        if (eventName) {
            if (Array.isArray(eventName) && eventName.length > 1) {
                if (dataLayer['pageCategory'] == 'tunnel') {
                    dataLayer = {
                        ...dataLayer,
                        event: event,
                        eventCategory: eventCategory,
                        eventAction: eventAction,
                        eventName: eventName.join()
                    }
                    window.dataLayer.push(dataLayer)
                    return;
                } else {
                    eventName.forEach((singleEvent: any) => {
                        dataLayer = {
                            ...dataLayer,
                            event: event,
                            eventCategory: eventCategory,
                            eventAction: eventAction,
                            eventName: singleEvent
                        }
                        window.dataLayer.push(dataLayer)
                    })
                    return;
                }

            } else {
                if (dataLayer['pageCategory'] == 'tunnel' && eventAction == 'fermer') {
                    dataLayer['eventCategory'] = dataLayer['pageName'].split('/')[0]
                    dataLayer['eventName'] = dataLayer['pageName'].split('/')[1]
                    window.dataLayer.push(dataLayer)
                } else {
                    dataLayer = {
                        ...dataLayer,
                        event: event,
                        eventCategory: eventCategory,
                        eventAction: eventAction,
                        eventName: eventName
                    }
                    if (event != 'click' || eventAction === 'etape-precedente') {
                        window.dataLayer.push(dataLayer)
                    }
                    window.dataLayer.push(dataLayer)
                }
            }
        } else {
            dataLayer = {
                ...dataLayer,
                event: event,
                eventCategory: eventCategory,
                eventAction: eventAction,
            }
            window.dataLayer.push(dataLayer)
        }
    }

    if (errors != 0) {
        dataLayer['eventValue'] = errors
    }

}

//Formulaires type tunnel
let objArray: Array<object> = []
let obj = {}

export function sendTunnelForm(pageName: { [key: string]: string }, pageCategory?: { [key: string]: string }, productAction?: { [key: string]: string }, productCheckout?: any, isConfirmation = false, leadId?: any): void {

    window.dataLayer = window.dataLayer || [];
    const namesArray: string[] = []
    Object.values(pageName).forEach((value) => {
        namesArray.push(value)
    });
    const joinedNames = namesArray.join('/')

    dataLayer = {
        ...dataLayer,
        pageName: joinedNames,
    }
    dataLayer['pageCategory'] = pageCategory?.categoryName
    // dataLayer['pageName'] = joinedNames
    dataLayer['productAction'] = productAction?.actionName
    let confirmationProductCheckout = []

    if (isConfirmation) {
        dataLayer['event'] = productAction?.actionName
        setTimeout(() => {
            dataLayer['leadId'] = leadId?.referenceUid
        }, 200)

        if(productCheckout.productCheckout) {
            if(Array.isArray(productCheckout.productCheckout)) {
                confirmationProductCheckout = productCheckout.productCheckout
            } else {
                confirmationProductCheckout = JSON.parse(productCheckout.productCheckout)
            }
        } else {
            confirmationProductCheckout = productCheckout['id']
        }

        if (Array.isArray(confirmationProductCheckout)) {
            objArray = []
            confirmationProductCheckout.forEach((item: any) => {
                obj = {
                    'name': item.name ? item.name : item,
                    'id': item.id ? item.id : item,
                    'category': item.category ? item.category : item,
                    'price': 1,
                    'brand': 'Tryba',
                    'quantity': 1,
                }
                objArray.push(obj)
            })
        } else {
            objArray = []
            const obj = {
                'name': confirmationProductCheckout,
                'id': confirmationProductCheckout,
                'category': confirmationProductCheckout,
                'price': 1,
                'brand': 'Tryba',
                'quantity': 1,
            }
            objArray.push(obj)
        }

        dataLayer['productPurchase'] = objArray
    }

    if (productCheckout != undefined && productCheckout != null && confirmationProductCheckout !== null && confirmationProductCheckout !== undefined && confirmationProductCheckout.length == 0) {

        objArray = []
        if (Array.isArray(productCheckout.choicesArray)) {
            productCheckout.choicesArray.forEach(item => {
                obj = {
                    'name': item.name,
                    'id': item.id,
                    'category': item.category,
                    'price': 1,
                    'brand': 'Tryba',
                    'quantity': 1,
                }
                objArray.push(obj)
            })
        } else {
            objArray = []
            const obj = {
                'name': productCheckout?.name,
                'id': productCheckout?.id,
                'category': productCheckout?.category,
                'price': 1,
                'brand': 'Tryba',
                'quantity': 1,
            }
            objArray.push(obj)
        }
        dataLayer['productCheckout'] = objArray
    }
    window.dataLayer.push(dataLayer)
}

//Formulaires LP
export function sendLpForm(pageName: { [key: string]: string }, pageCategory?: { [key: string]: string }): void {
    window.dataLayer = window.dataLayer || [];
    const namesArray: string[] = []
    Object.values(pageName).forEach((value) => {
        namesArray.push(value)
    });
    const joinedNames = namesArray.join('/')

    dataLayer['pageCategory'] = pageCategory?.categoryName
    dataLayer['pageName'] = joinedNames

    window.dataLayer.push(dataLayer)
}

//Pages basiques
export function sendPageDatas(pageName: { [key: string]: string }, pageCategory?: { [key: string]: string }): void {
    window.dataLayer = window.dataLayer || [];
    const namesArray: string[] = []
    if (pageName.slots) {
        Object.values(pageName.slots).forEach((value) => {
            namesArray.push(value)
        });
    } else {
        Object.values(pageName).forEach((value) => {
            namesArray.push(value)
        });
    }
    const joinedNames = namesArray.join('/')
    dataLayer['pageCategory'] = pageCategory?.categoryName
    dataLayer['pageName'] = joinedNames

    window.dataLayer.push(dataLayer)
}

//Pages basiques avec parametre action
export function sendPageActionDatas(actionName: { [key: string]: string }, pageName: { [key: string]: string }, pageCategory?: { [key: string]: string }): void {
    window.dataLayer = window.dataLayer || [];
    const namesArray: string[] = []
    Object.values(pageName.slots).forEach((value) => {
        namesArray.push(value)
    });
    const joinedNames = namesArray.join('/')

    dataLayer['pageCategory'] = pageCategory?.categoryName
    dataLayer['pageName'] = joinedNames
    dataLayer['pageAction'] = actionName.actionName

    window.dataLayer.push(dataLayer)
}

//Pages basiques avec parametre action
export function sendProductDatas(actionName: { [key: string]: string }, pageName: { [key: string]: string }, pageCategory?: { [key: string]: string }, productDetail?: any): void {
    window.dataLayer = window.dataLayer || [];
    const namesArray: string[] = []
    Object.values(pageName.slots).forEach((value) => {
        namesArray.push(value)
    });
    const joinedNames = namesArray.join('/')

    dataLayer['pageCategory'] = pageCategory?.categoryName
    dataLayer['pageName'] = joinedNames
    dataLayer['pageAction'] = actionName.actionName

    dataLayer['productDetail'] = [
        {
            'name': productDetail.productDetail.name,
            'id': productDetail.productDetail.id,
            'category': productDetail.productDetail.category,
            'price': 1,
            'brand': 'Tryba',
            'variant': productDetail.productDetail.variant,
            'quantity': 1,
        }
    ]
    window.dataLayer.push(dataLayer)
}

//Page de résultat de recherches
export function sendSearchDatas(q, nbResults) {
    dataLayer['q'] = q
    dataLayer['results'] = nbResults
    window.dataLayer.push(dataLayer)
}
